import React from 'react'
import { RevisionList } from './list/page'

export const RevisionPage = () => <RevisionList />
